document.addEventListener("DOMContentLoaded", function() {
  // 获取所有的checkbox和slider组件
  var checkboxes = document.querySelectorAll('.collection-toggle');
  var sliders = document.querySelectorAll('.multi-collecton-items');

  // 遍历每个checkbox
  checkboxes.forEach(function(checkbox, index) {
    // 监听点击事件
    checkbox.addEventListener('click', function() {
      // 切换active类
      sliders.forEach(function(slider, sliderIndex) {
        if (index === sliderIndex) {
          slider.classList.add('active');
        } else {
          slider.classList.remove('active');
        }
      });
    });
  });
});
